/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';
var __iconNode = [["path", {
  d: "M5 12h14",
  key: "1ays0h"
}]];
var Minus = createLucideIcon("Minus", __iconNode);
export { __iconNode, Minus as default };